module.exports = __webpack_public_path__ + "img/MBT-Tohu-Reversed-short.2ebfc31f.png";